<form class="d-inline-flex" [formGroup]="form">
  <div
    class="faq-form mr-3"
    style="color: darkgrey; display: flex; margin-left: 10px"
  >
    <i class="search-icon" data-feather="search"></i>
    <div>
      <div class="input-group" style="width: 19rem">
        <input
          id="table-complete-search"
          type="text"
          class="form-control"
          [placeholder]="placeholder"
          [formControlName]="inputFormControlName"
        />
        <span *ngIf="filterOptions"
          class="input-group-text p-0"
          style="background-color: transparent"
        >
          <app-general-filter
            [filter]="filterOptions"
            (optionSelected)="saveOption($event)"
          >
          </app-general-filter>
        </span>
      </div>
    </div>
  </div>
</form>
